import dayjs from 'dayjs'
import * as XLSX from 'xlsx'

const buildFilename = (prefix, chartName, { sampleDateFilterApplied, isZoomed } = {}) => {
    const generated = dayjs().format('YYYYMMDD')
    const status = sampleDateFilterApplied || isZoomed ? 'Filtered' : 'Full'
    const parts = [prefix, chartName, status, generated].filter(Boolean)
    return parts.join('_') + '.xlsx'
}

const downloadChartXlsx = ({ headers, rows, prefix, chartName, sampleDateFilterApplied, isZoomed }) => {
    const exportData = rows.map(row =>
        headers.reduce((obj, h) => {
            obj[h] = row[h] ?? ''
            return obj
        }, {})
    )
    const filename = buildFilename(prefix, chartName, { sampleDateFilterApplied, isZoomed })
    const wb = XLSX.utils.book_new()
    const ws = XLSX.utils.json_to_sheet(exportData)
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
    XLSX.writeFile(wb, filename)
}

export { downloadChartXlsx, buildFilename }
export default downloadChartXlsx
